<template>
<v-app>
<v-container fluid class="ma-0 pa-0" width="100%">
<v-card style="margin:20px">
 <v-data-table
    dense
    :headers="headers"
    :items="ppnItems"
    hide-actions
  >
  <template slot="items" slot-scope="props">
    <tr>
      <td>{{ props.item.ppn_num }}</td>
      <td>{{ props.item.ppn_name }}</td>
      <td>{{ props.item.inspection_date }}</td>
      <td>{{ props.item.worker }}</td>
      <td>
        <v-btn color="grey" @click="getExcel(props.item.ppn_id)">
            <span>xls</span>
            <v-icon>mdi-download</v-icon>
        </v-btn>
      </td>
      <td><v-checkbox v-model="props.item.selected" primary hide-details></v-checkbox></td>
    </tr>
  </template>
  </v-data-table>
</v-card>
</v-container>
</v-app>
</template>
<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
export default {
  name: 'ppnCards',
  components: {
  },
  data () {
    return {
        headers: [
          { text: 'Имя ППН', value: 'ppn_num'},
          { text: 'Имя перечета', value: 'ppn_name'},
          { text: 'Дата перечета', value: 'inspection_date'},
          { text: 'Исполнитель', value: 'worker'},
          { text: 'Скачать', value: 'download'},
          { text: 'Выбрать', value: 'selected'}
        ],
        groupBy: [{ key: 'ppn_num', order: 'asc' }],
    }
  },
  mounted: function() {
    //this.getPlan(this.$route.query.filialid, this.planYear)
    //this.getPpnCards()
  },
  computed: {
    ppnItems() {
        return this.$store.state.glpm.ppnItems
    }
  },
  methods: {
    getExcel(id) {
      const form = new FormData();
      form.append("id", id);
      return fetch('php_scripts/glpm/ppn/ppn_to_xls.php', {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          const a = document.createElement("a");

          a.setAttribute("href", res.file);
          a.setAttribute("download", res.name);

          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        //const a = document.createElement("a");
        //a.setAttribute("href", '../gis/php_scripts/glpm/ppn/ppn_to_xls.php?id='+id);
        //document.body.appendChild(a);
        //a.click();
        //a.remove();
    },
    getPpnCards() {
        this.$store.dispatch('getPpnCards')
    }
  }
}
</script>
<style scoped>
.v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.v-input {
  font-size: 13px;
  min-width: 80px;
  max-width: 80px; 
}
.v-input input {
  max-height: 20px;
}
</style>